import { config } from "JS/Config";
import { User, UserTeamInfo } from "JS/Models";
import { BaseService } from "../BaseService";
import { LandingPageHelper } from "./LandingPageHelper";
import { appConstants } from "JS/Helpers/Constants";
import { AxiosResponse } from "axios";

export class HomeService extends BaseService {
    private helper = new LandingPageHelper();

    async getTeamsStatusForUser(
        sendCall: boolean,
        defaultTeamInfo: UserTeamInfo,
    ) {
        if (sendCall || !defaultTeamInfo?.teamName)
            return await this.ngCall<UserTeamInfo>(
                "get",
                appConstants.ngEndpoints.getTeamInfo(config?.user?.memberId),
            );
        else
            return new Promise<AxiosResponse<UserTeamInfo>>((res) => {
                res({
                    data: defaultTeamInfo,
                    status: 200,
                    statusText: "OK",
                    headers: {},
                    config: { headers: {} as any },
                });
            });
    }

    async getLandingPageJsonFile(
        filePath: string,
    ): Promise<AWS.S3.GetObjectOutput> {
        return new Promise((res, _) => {
            this.helper.initConfig();
            const s3 = this.helper.getS3();
            s3.getObject(this.helper.jsonFileParams(filePath), (err, data) => {
                if (err) res(null);
                res(data);
            });
        });
    }

    getExternalSso = (accessToken: string, memberId: string) =>
        this.ngCall<Omit<User, "memberId">>(
            "post",
            appConstants.ngEndpoints.sso,
            {
                accessToken,
                memberId,
                clientId: 2,
                scope: "media_scope",
                platform: "web",
            },
        );
}
